module.exports = __webpack_public_path__ + "img/cobra_screenshot_2.04dca134.jpg";